import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';

@Component({
  selector: 'app-completar-datos-autorizar-transacciones',
  templateUrl: './completar-datos-autorizar-transacciones.component.html',
  styleUrls: ['./completar-datos-autorizar-transacciones.component.scss'],
})
export class CompletarDatosAutorizarTransaccionesComponent implements OnInit {
  form: FormGroup;

  tipo_validaciones = ['Cheque de Gerencia', 'Transferencia Interbancaria'];
  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      tipo_validacion: [
        values ? values.tipo_validacion : '',
        [Validators.required],
      ],
      ci_persona: [
        values ? values.ci_persona : '',
        [Validators.required, Validators.pattern(Regexs.regexCiRif)],
      ],
      nombre_apellido: [
        values ? values.nombre_apellido : '',
        [Validators.required],
      ],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
